<template>
<div class="shopMobCoupon">
    <div class="outerBox">
        <div class="couponBox">
            <div class="coupon" v-for="(obj, index) in setting.datalist" :key="index"
                 :style="{backgroundImage: obj.ishave ? `url(${redimg})` : `url(${ashimg})`}">
                <div class="couponPrice">
                    <div class="priceBox"><span>￥</span>{{obj.price}}</div>
                    <div class="couponClass">{{obj.requireprice}}</div>
                </div>
                <div class="getCouponBox">
                    <span>{{obj.ishave?'领取':'已领完'}}</span>
                    <!-- <span>已领完</span> -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import {getCouponVoucherList} from 'api/api'
export default {
    name: 'shopMobCoupon',
    data() {
        return {
            ashimg: require('../../../../../common/images/shop/discount-ash.png'),
            redimg: require('../../../../../common/images/shop/discount-red.png'),
            discountCoupon: [
                {ashimg: require('../../../../../common/images/shop/discount-ash.png'), redimg: require('../../../../../common/images/shop/discount-red.png'), price: '100', couponClass: '无门槛优惠券'},
                {ashimg: require('../../../../../common/images/shop/discount-ash.png'), redimg: require('../../../../../common/images/shop/discount-red.png'), price: '100', couponClass: '无门槛优惠券'},
            ]
        }
    },
    props: ['setting'],
    mounted() {
        this._getCouponVoucherList()
    },
    methods: {
        _getCouponVoucherList() {
            this.setLoading(true)
            getCouponVoucherList({
                data: {
                    ispublic: '',
                    subject: '',
                    page: 1,
                    pageSize: 2
                },
                success: data => {
                    let tmp = []
                    data.data.forEach(obj => {
                        tmp.push({
                            objectid: obj.innerid,
                            objectname: obj.name,
                            price: obj.faceprice,
                            usescopetype: obj.usescopetype,
                            requireprice: obj.facepricetext,
                            ishave: obj.currentgetcount - obj.currentusecount
                        })
                    })
                    let tmpList = $.extend(true, [], this.shopMob)
                    tmpList.forEach((obj,index) => {
                        if (obj.comtype === 'coupon') {
                            obj.datalist = tmp
                        }
                    })
                    this.setShopMob(tmpList)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setShopMob',
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shopMobCoupon {
    width: 100%;
    height: 4.48rem;
    box-sizing: border-box;
    padding: 0.64rem 0 0.64rem 0.64rem;
    overflow: hidden;
    .outerBox{
        width: 15rem;
        height: 4.48rem;
        overflow: scroll;
    }
    .couponBox{
        display: flex;
        .coupon{
            width: 6rem;
            height: 3.2rem;
            display: flex;
            background-size: 6rem 3.2rem;
            color: #fff;
            margin-right: 0.64rem;
            .couponPrice{
                width: 3.8rem;
                box-sizing: border-box;
                padding: 0.74rem 0 0.74rem 0.74rem;
                .couponClass{
                    font-size: 0.4rem;
                    margin-top: 0.16rem;
                }
                .priceBox{
                    font-size: 0.96rem;
                    span{
                        font-size: 0.4rem;
                    }
                }
            }
            .getCouponBox{
                width: 2.2rem;
                text-align: center;
                line-height: 3.2rem;
            }
        }
    }
}
</style>
